import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fill-height":""}},[_c(VLayout,{attrs:{"row":""}},[_c(VFlex,{attrs:{"xs12":"","sm10":"","md6":"","text-center":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('qrcode-stream',{staticClass:"element",on:{"decode":_vm.onDecode,"init":_vm.onInit}}),_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])],1)],1),_c('h1',[_vm._v(_vm._s(_vm.result))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }